export const products = [
  {
    id: "peas",
    category: "cartridges",
    name: "горох",
    price: "50",
    kit: {"Картридж": "1 шт."},
    images: [
      "/goroh.jpg",
      "/goroh1.jpg",
      "/goroh2.jpg"
    ],
    description: "Мікрозелень гороху є багатим джерелом фітоестрогенів. Ці сполуки рослинного походження часто відомі через здатність знижувати ризик раку молочної залози, серцевих захворювань та остеопорозу.",
  },
  {
    id: "nasturtium",
    category: "cartridges",
    name: "настурція",
    price: "50",
    kit: {"Картридж": "1 шт."},
    images: [
      "/nast1.jpg",
      "/nast2.jpg",
      "/nast3.jpg",
      "/nast4.jpg",
    ],
    description: "Мікрозелень настурції — незамінна складова у дієтичному раціоні та у здоровому зарчуванні. Сприяє нормалізації травлення, зниженню ваги та уповільнює старіння організму. Має пряно-перцевий присмак, доповнює смакову палітру овочевих, м'ясних та рибних страв.",
  },
  {
    id: "radish",
    category: "cartridges",
    name: "редиска",
    price: "50",
    kit: {"Картридж": "1 шт."},
    images: [
      "/redis1.jpg",
      "/redis2.jpg",
      "/redis3.jpg",
      "/redis4.jpg"
    ],
    description: "У вигляді мікрозелені редиска корисна для травлення, покращує апетит та стан шкіри, нормалізує цукор у крові, зменшує кількість холестерину, сприяє зниженню ваги, зміцнює серцево-судинну систему. Має жовчогінний і протинабряковий ефект.",
  },
  {
    id: "watercres",
    category: "cartridges",
    name: "кресс-салат",
    price: "50",
    kit: {"Картридж": "1 шт."},
    images: [
      "/cress1.jpg",
      "/cress2.jpg"
    ],
    description: "Дезінфікує ротову порожнину. Вживання мікрозелені крес-салату на ніч допомагає позбутися від безсоння і підвищує опірність нервової системи до стресів. Мікрозелень крес-салату нормалізує роботу щитовидної залози, покращує мозкову діяльність і допомагає позбутися від гіпертеріоза.",
  },
  {
    id: "mustard",
    category: "cartridges",
    name: "гірчиця",
    price: "50",
    kit: {"Картридж": "1 шт."},
    images: [
      "/girch1.jpg",
      "/girch2.jpg",
      "/girch3.jpg"
    ],
    description: "Зміцнює організм, підвищує імунітет та опір несприятливим впливам інфекцій, вірусів, радіації. Допомагає швидше одужувати при застуді, грипі, ГРВІ. Покращує травлення, прискорює обмін речовин. Допомагає нормалізувати вагу.",
  },
  {
    id: "T1",
    name: "T1",
    category: "racks", 
    images: [
      "/t1-pdp1.png",
      "/t1-pdp2.png",
      "/t1-pdp3.png",
    ],
    description: "One compartment for a microgreens cartridge. A great solution for starting out.",
    price: 70,
    kit: {
      "Sprayer with level": "1 pc.",
      "Wire (micro USB)": "5 m.",
      "Instructions": "1 pc.",
      "Cartridge": "1 pc.",
      "Tray": "1 pc.",
    },
    lamp: 1,
    power: 3,
  },
  {
    id: "T2", 
    name: "T2",
    category: "racks",
    images: [
      "/t2-pdp1.png",
      "/t2-pdp2.png",
      "/t2-pdp3.png",
    ],
    description: "Two compartments for microgreens cartridges. A great solution for those who want more variety.",
    price: 90,
    kit: {
      "Sprayer with level": "1 pc.",
      "Wire (micro USB)": "5 m.",
      "Instructions": "1 pc.",
      "Cartridge": "2 pcs.",
      "Tray": "2 pcs.",
    },
    lamp: 1,
    power: 6,
  }
];

export default products;